<template>
  <div class="wrapper">
    <FORM ref="childForm" @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="bthClick" :pageData="pageData"></table-page>
    <UPDATE ref="childUpdate" @submit="submit" :updateData="updateData"></UPDATE>
    <UPDATE ref="childUpdateEdit" @submit="submitEdit" :updateData="updateEditData"></UPDATE>
  </div>
</template>

<script>
//table封装组件
import tablePage from '@/components/page/table.vue'
import FORM from '@/components/page/form.vue'
import URL from '@/views/cms/util/url'
import UPDATE from '@/components/page/update.vue'
import Qs from 'qs'
import axios from 'axios'
import DateUtil from '@/utils/IM/tradeDataUtil'

let langs = {}, roles = {}
let siteList = []
export default {
  name: 'list',
  components: {
    tablePage,
    FORM,
    UPDATE
  },
  created() {
    this.initLangs()
    this.initRoles()
  },
  methods: {
    checkbox(row) {
      this.deleteIds = row.map(key => key.id).join(',')
    },
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },
    initLangs() {
      this.$axios.post(URL.lang.query, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              langs[data[i].code] = data[i].displayName
            }
            this.$refs.childTable.defaultQueryData(this.queryData)
          }
        }
      })
    },
    initRoles() {
      this.$axios.post(URL.company.roles, {}).then(res => {
        if (res.code == 0) {
          let data = res.result
          if (data && data.length > 0) {
            for (const i in data) {
              roles[data[i].id] = data[i].name
            }
          }
        }
      })
    },
    initCompanySpiderSrcQuery(row) {
      let option = {
        companyCode: row.code
      }
      this.$axios.post(URL.company.companySpiderSrcQuery, Qs.stringify(option || {})).then(res => {
        if (res.code == 0) {
          let data = JSON.parse(JSON.stringify(res.result)), checkList = [], flag = false
          if (data && data.length > 0) {
            siteList = data
            for (const i in data) {
              siteList[i].checkAllName = data[i].name
              siteList[i].check = 'k' + i
              siteList[i].styleList = []
              let arr = {}
              for (const j in data[i].spiderRules) {
                if (data[i].spiderRules[j].companySrcChecked) {
                  flag = true
                  checkList.push(data[i].spiderRules[j].id.toString())
                }
                arr[data[i].spiderRules[j].id] = data[i].spiderRules[j].netName
              }
              if (!flag) checkList = []
              siteList[i].styleList.push(arr)
              delete siteList[i].spiderRules
            }
            this.updateEditData.cols.find(function(e) {
              return e.field == 'spiderIds'
            }).selectList = siteList
            this.updateEditData.cols.find(function(e) {
              return e.field == 'spiderIds'
            }).data = checkList
            row.spiderIds = checkList
            this.$refs.childUpdateEdit.open(row)
          }else this.$message.warning("语言配置不匹配")
        }
      })
    },
    /*表格按钮点击事件*/
    bthClick(clickName, row) {
      if (clickName == 'update') {
        row.lang = row.lang.split(",");
        this.$refs.childUpdate.open(row)
      } else if (clickName == 'source') {
        row.companyCode = row.code
        this.initCompanySpiderSrcQuery(row)
      } else if (clickName == 'delete') {
        this.dataChange(URL.company.del + '/' + row.id, { id: row.id }, res => {
          if (res.code == 0) {
            this.$refs.childTable.defaultGetData(this.queryData)
            this.$message.success('suc')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },
    /*查询表单按钮点击事件*/
    formclick(clickName, data) {
      if ('查询' == clickName) {
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)
      } else if ('新增' == clickName) {
        this.$refs.childUpdate.open()
      }
    },
    /*新增或跟提交数据触发事件*/
    submit(model) {
      model.lang = model.lang.join(',')
      //根据是否包含id更新还是添加
      this.dataChange((model.id != undefined && model.id != null && model.id != '') ? URL.company.edit : URL.company.edit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        }
      })
    },
    submitEdit(model) {
      model.spiderIds = model.spiderIds.filter((item) => {
        return item.indexOf('k') <= -1
      }).join(',')
      //根据是否包含id更新还是添加
      this.dataChange((model.id != undefined && model.id != null && model.id != '') ? URL.company.companySpiderSrcEdit : URL.company.companySpiderSrcEdit, model, res => {
        if (res.code == 0) {
          this.$refs.childUpdate.close()
          this.$message.success('操作成功')
          this.$refs.childTable.defaultGetData(this.queryData)
        }
      })
    }
  },
  data() {
    return {
      deleteIds: '',
      queryData: {},
      /*新增或更新*/
      updateData: {
        cols: [
          { title: 'id', field: 'id', hidden: true },
          { title: 'name', field: 'name', required: true },
          { title: 'code', field: 'code', required: true },
          { title: 'lang', field: 'lang', required: true, type: 4, optionList: langs, data: [] },
          { title: 'roleId', field: 'roleId', required: true, type: 2, optionList: roles,isNumber:true }
        ]
      },
      /*配置资源*/
      updateEditData: {
        cols: [
          { title: 'companyCode', field: 'companyCode', hidden: true },
          {
            title: '当前抓取资源（勾选即配置该资讯来源）',
            field: 'spiderIds',
            type: 8,
            selectList: siteList,
            position: 'newLine',
            data: []
          }
        ]
      },
      /*from查询表单*/
      formData: {
        hasLable: true,
        cols: [
          { click: '查询', auth: 'cms:company:list' },
          { click: '新增', auth: 'cms:company:save' }
        ]
      },
      /*table生成*/
      pageData: {
        queryUrl: URL.company.query, //请求路径和参数
        selection: true,
        sequence: false,
        cols: [
          { title: '主键', field: 'id', minWidth: 30 },
          { title: 'name', field: 'name' },
          { title: 'code', field: 'code' },
          { title: 'lang', field: 'lang', render: (data, full) => {
              let result = "";
              let split = data.split(",");
              for (let i in split) {
                result = result + "," + langs[split[i]];
              }
              return result.slice(1);
            }
          },
          {
            title: 'roleId', field: 'roleId', render: (data, full) => {
              return roles[data]
            }
          },
          { title: 'createBy', field: 'createBy' },
          {
            title: 'ctime', field: 'ctime', render: (data, full) => {
              return DateUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')
            }
          },
          {
            title: '操作', btnClick: [
              { name: '删除', click: 'delete', type: 'primary', icon: 'el-icon-delete', auth: 'cms:company:del' },
              { name: '修改', click: 'update', type: 'primary', icon: 'el-icon-edit', auth: 'cms:company:edit' },
              { name: '配置資源', click: 'source', type: 'primary', icon: 'el-icon-edit', auth: 'cms:company:source' }
            ]
          }

        ]
      }
    }
  }
}
</script>
